module.exports = __webpack_public_path__ + "static/media/SMC.ef298bf1.png";